export enum Role {
  HQ = 'HQ',
  /**
   **Utente LOCAL HQ
   * Stock di tutte le companies del gruppo di appartenenza
   * Prezzi di tutte le valute (no prezzo in primo piano in PDP)
   */
  GlobalHQ = 'GlobalHQ',
  /**
   **Utente GLOBAL HQ
   * Stock di tutte le companies
   * Prezzi di tutte le valute (no prezzo in primo piano in PDP)
   */
  NoStore = 'NoStore',
  /**
  **Utente NOSTORE
  * Stock non visibile
  * Prezzi non visibili
  */
  Store = 'Store',
  /**
   **Utente STORE
   * Stock della propria company
   * Prezzi in tutte le valute con primo piano in PDP del prezzo della propria company
   */
  Bp = 'Bp',
}
